'use strict';

/**
 * @param {Function} fn
 * @param {number} wait
 * @param {Object} [options]
 * @returns {Function}
 */
export default function throttle(fn, wait, options = {}) {
    const trailing = options.trailing !== false;
    let lastCall = 0;
    let timeout;
    function throttled(...args) {
        const now = Date.now();
        const remaining = wait - (now - lastCall);
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            lastCall = now;
            fn.apply(this, args);
        } else if (trailing && !timeout) {
            timeout = setTimeout(() => {
                lastCall = Date.now();
                timeout = null;
                fn.apply(this, args);
            }, remaining);
        }
    }
    throttled.cancel = function cancel() {
        clearTimeout(timeout);
        timeout = null;
        lastCall = 0;
        if (typeof fn.cancel === 'function') {
            fn.cancel();
        }
    };
    return throttled;
}
